import { AbstractEntityService } from "./AbstractEntityService";

export class RatesService extends AbstractEntityService {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }

    ratesBase(propertyId) {
        return `${this.baseUrl}/properties/${propertyId}/rates`;
    }

    async findByRoom(propertyId, roomId) {
        const url = `${this.ratesBase(propertyId)}/room/${roomId}`;

        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, `Unable to load rates for room ${roomId} - please see server logs for more details`);
        }
    }

    async create(propertyId, roomId, planId, price) {
        const url = `${this.ratesBase(propertyId)}/room/${roomId}/plan/${planId}`;

        const body = {
            price: price
        }

        try {
            return await super.create(url, body);
        } catch (error) {
            this.handleError(error, `Unable to create rate for room ${roomId} and plan ${planId} - please see server logs for more details`);
        }
    }

    async update(propertyId, roomId, planId, price) {
        const url = `${this.ratesBase(propertyId)}/room/${roomId}/plan/${planId}`;

        const body = {
            price: price
        }

        try {
            return await super.update(url, body);
        } catch (error) {
            this.handleError(error, `Unable to update rate for room ${roomId} and plan ${planId} - please see server logs for more details`);
        }
    }

    async updateAll(propertyId, roomId, rates) {
        const url = `${this.ratesBase(propertyId)}/room/${roomId}`;

        try {
            return await super.update(url, rates);
        } catch (error) {
            this.handleError(error, `Unable to update rates for room ${roomId} - please see server logs for more details`);
        }
    }

    async delete(propertyId, roomId, planId) {
        const url = `${this.ratesBase(propertyId)}/room/${roomId}/plan/${planId}`;

        try {
            return await super.delete(url);
        } catch (error) {
            this.handleError(error, `Unable to delete rate for room ${roomId} and plan ${planId} - please see server logs for more details`);
        }
    }
}
